import { Chip, Typography } from '@mui/material'
import { FC, useMemo } from 'react'

import { useTranslation } from '@/core'

export type MemberWhetTagProps = {
  month: number
}

export const MemberWhetTag: FC<MemberWhetTagProps> = ({ month }) => {
  const { t } = useTranslation()

  const { bgcolor, color } = useMemo(() => {
    if (month === 1) {
      return { bgcolor: 'primary.light', color: 'black' }
    }
    if (month > 3) {
      return { bgcolor: 'primary.main', color: 'white' }
    }
    return { bgcolor: 'primary.dark', color: 'white' }
  }, [month])

  return (
    <Chip
      size="small"
      sx={{ height: 16, borderRadius: '2px', py: 1, bgcolor }}
      label={
        <Typography
          variant="overline"
          display="block"
          sx={{ color, textTransform: 'unset' }}
        >
          {t('monthContinuation', { month })}
        </Typography>
      }
    />
  )
}
